import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.css'
import App from './App'

const root = document.getElementById('root')!

// Clear the inline splash before mounting React so it doesn't double-paint.
const splash = document.getElementById('vice-splash')
splash?.remove()

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
